import type { CategoryId } from '../game/types'
import { CATEGORIES, PUZZLE_SIZE } from '../game/constants'
import { dayKey, puzzleNumber } from '../game/daily'
import { readResultStatus } from '../game/persistence'
import { useLang } from '../i18n/LangContext'
import { SportIcon } from './SportIcon'

export function Home({ onPick }: { onPick: (c: CategoryId) => void }) {
  const today = dayKey()
  const { t } = useLang()

  return (
    <section className="home">
      <div className="home-head">
        <p className="eyebrow">
          {t.daily} № {puzzleNumber()}
        </p>
        <h1 className="display-title">{t.tagline}</h1>
        <p className="lede">{t.lede(PUZZLE_SIZE)}</p>
      </div>

      <ul className="index">
        {CATEGORIES.map((c, i) => {
          const status = readResultStatus(today, c.id)
          return (
            <li key={c.id}>
              <button className="index-row" onClick={() => onPick(c.id)}>
                <span className="index-no" aria-hidden="true">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className={`mark mark-${c.id}`} aria-hidden="true">
                  <SportIcon sport={c.id} size={20} />
                </span>
                <span className="index-name">{t.categories[c.id]}</span>
                {status === 'won' && <span className="tag tag-done">{t.tagSolved}</span>}
                {status === 'lost' && <span className="tag tag-fail">{t.tagPlayed}</span>}
                {status === 'playing' && (
                  <span className="tag tag-live">{t.tagResume}</span>
                )}
                <span className="index-go" aria-hidden="true">
                  →
                </span>
              </button>
            </li>
          )
        })}
      </ul>

      <p className="home-foot">{t.homeFoot}</p>
    </section>
  )
}
